<template>
  <div class="filter-menu" v-if="selectedEffect && selectedEffect.content">
    <MenuHeader title="添加滤镜" />
    <div class="filter-list">
      <button
        type="button"
        class="filter-list__item"
        v-for="item in filterList"
        :key="item.value"
        @click="setFilter(item.value)"
      >
        <div
          class="filter-item"
          :class="{
            'filter-item--selected':
              item.value === selectedEffect.content.filterName ||
              (!item.value && !selectedEffect.content.filterName)
          }"
        >
          <svg class="filter-item__content" viewBox="0 0 74 74">
            <image
              href="https://img001.aivideo8.com/ai_video/U0-2020-07-22-img-1595380428532.jpg"
              x="0"
              y="0"
              width="74"
              height="74"
              :filter="getFilterName(item.value)"
            />
          </svg>
        </div>
        <div class="filter-list__text">
          {{ item.name }}
        </div>
      </button>
    </div>
    <collapse-title class="filter-adjustments" title="高级设置" :open="true">
      <!-- <label-slider
        useModel
        :min="0"
        :max="2"
        :step="0.1"
        label="亮度"
        v-model="selectedEffect.content.brightness"
      /> -->
      <label-slider
        useModel
        :min="0"
        :max="100"
        :step="1"
        label="高斯模糊"
        v-model="filterParams.blur"
      />
      <label-slider
        useModel
        :min="0"
        :max="200"
        :step="1"
        label="对比度"
        v-model="filterParams.contrast"
        percentage
      />
      <LabelSwitch label="灰阶" v-model="filterParams.grayscale" />
      <LabelSwitch label="色相反转" v-model="filterParams.invert" />
    </collapse-title>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MenuHeader from "../base/MenuHeader";
import CollapseTitle from '../base/CollapseTitle';
import LabelSlider from '../base/LabelSlider';
import LabelSwitch from '../base/LabelSwitch';

export default {
  components: { MenuHeader, CollapseTitle, LabelSwitch, LabelSlider },
  data: function () {
    return {
      filterList: [
        { name: '原图', value: '' },
        { name: '锐化', value: 'sharpen' },
        { name: '轮廓', value: 'contour' },
        { name: '边缘增强', value: 'edgeEnhance' },
        { name: '加深', value: 'dark' },
        { name: '灯光', value: 'light' },
        { name: '岩浆', value: 'magma' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedEffect']),
    filterParams() {
      const efc = this.selectedEffect && this.selectedEffect.content;
      return efc && efc.filterParams;
    }
  },
  methods: {
    setFilter(value) {
      const efc = this.selectedEffect && this.selectedEffect.content;
      if (efc) {
        this.$set(efc, 'filterName', value);
      }
    },
    getFilterName(value) {
      if (!value) {
        return 'none';
      }
      return `url(#filter${value})`;
    }
  },
  watch: {
  }
}
</script>

<style scoped>
.filter-menu {
  background: rgba(247, 248, 249, 1);
  box-shadow: -1px 0 0 0 rgba(220, 220, 222, 1);
  padding: 10px 18px;
  height: 100%;
  overflow-y: auto;
}

.filter-list {
  display: flex;
  flex-wrap: wrap;
  margin-right: -11px;
  align-items: flex-start;
  align-content: start;
  margin-bottom: 12px;
  font-size: 12px;
}

.filter-list__item:hover .filter-list__text,
.filter-list__item:focus .filter-list__text {
  color: #007eff;
}

.filter-list__item {
  width: calc(100% / 3 - 11px);
  margin: 11px 11px 0 0;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  border-radius: 0;
}

.filter-list__text {
  font-size: 12px;
  text-align: center;
  margin-top: 4px;
  cursor: default;
}

.filter-item {
  position: relative;
  background: #fff;
}

.filter-item:before {
  content: "";
  display: block;
  padding-bottom: 100%;
}

.filter-item__content,
.filter-item:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.filter-item:after {
  content: "";
  transition: 0.3s;
}

.filter-list__item:hover .filter-item:after,
.filter-list__item:focus .filter-item:after,
.filter-item--selected:after {
  box-shadow: inset 0 0 0 2px #007eff;
}

.filter-adjustments ::v-deep .label-slider .label {
  width: 25%;
}

.filter-adjustments ::v-deep .label-slider .setting-slider {
  width: 25%;
  flex-grow: 1;
  margin-left: 16px;
  margin-right: 16px;
}

.filter-adjustments ::v-deep .ant-collapse-content {
  margin-right: -18px;
}

.filter-adjustments
  ::v-deep
  > .ant-collapse-item
  > .ant-collapse-content
  > .ant-collapse-content-box {
  padding-right: 18px;
}
</style>